import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectMedicalHardshipStep = (state) => state.get('medicalHardshipStep');

const makeSelectMedicalHardshipStep = () => createSelector(
  selectMedicalHardshipStep,
  (stepMedicalHardshipState) => ({
    // Critical
    whatEventHappenedForCritical: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'whatEventHappenedForCritical']),
      ''
    ),
    whatDateThisOccur: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'whatDateThisOccur']),
      ''
    ),
    areYouInACareFacilityCurrentlyForCritical: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'areYouInACareFacilityCurrentlyForCritical']),
      ''
    ),
    typeOfCareFacilityForCritical: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'typeOfCareFacilityForCritical']),
      ''
    ),
    // Disability
    whatEventHappenedForDisability: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'whatEventHappenedForDisability']),
      ''
    ),
    dateOfAccidentForDisability: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'dateOfAccidentForDisability']),
      ''
    ),
    areYouInACareFacilityCurrentlyForDisability: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'areYouInACareFacilityCurrentlyForDisability']),
      ''
    ),
    typeOfCareFacilityForDisability: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'typeOfCareFacilityForDisability']),
      ''
    ),
    natureOfDismemberment: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'natureOfDismemberment']),
      ''
    ),
    whatDateDidThisOccurForDismemberment: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'whatDateDidThisOccurForDismemberment']),
      ''
    ),
    didYouGoToAHospitalCurrentlyForDismemberment: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'didYouGoToAHospitalCurrentlyForDismemberment']),
      ''
    ),
    areYouInACareFacilityCurrentlyForDismemberment: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'areYouInACareFacilityCurrentlyForDismemberment']),
      ''
    ),
    typeOfCareFacilityForDismemberment: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'typeOfCareFacilityForDismemberment']),
      ''
    ),
    didYourEmployerAllowYouAnApprovedLeaveOfAbsence: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'didYourEmployerAllowYouAnApprovedLeaveOfAbsence']),
      ''
    ),
    onWhatDateDidYourLeaveStart: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'onWhatDateDidYourLeaveStart']),
      ''
    ),
    employerName: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'employerName']),
      ''
    ),
    employerEmail: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'employerEmail']),
      ''
    ),
    areYouRetired: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'areYouRetired']),
      ''
    ),
    dateOfDeath: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'dateOfDeath']),
      ''
    ),
    enableTimeForCritical: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'enableTimeForCritical']),
      ''
    ),
    enableTimeForDisability: mapWithDefault(
      stepMedicalHardshipState,
      () => stepMedicalHardshipState.getIn(['form', 'enableTimeForDisability']),
      ''
    ),
  })
);

const makeSelectMedicalHardshipStepErrors = () =>
  createSelector(selectMedicalHardshipStep, (state) => state.get('errors'));

export {
  makeSelectMedicalHardshipStep,
  makeSelectMedicalHardshipStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/selectors.js